import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Hamburger from '../assets/HamburgerMenu';
import BuildNumber from '../assets/BuildNumber';
import styles from './Menu.css';

class Menu extends React.Component {
  constructor(props) {
    super(props);
    this.state = { menuToggled: false };

    this.handleClick = this.handleClick.bind(this);
    this.closeMenuClick = this.closeMenuClick.bind(this);
  }

  handleClick() {
    this.setState(prevState => ({ menuToggled: !prevState.menuToggled }));
  }

  closeMenuClick() {
    this.setState(() => ({ menuToggled: false }));
  }
  render() {
    return (
      <div>
        <div
          className={
            this.state.menuToggled ? styles.menuShade : styles.menuShadeHidden
          }
          onClick={this.state.menuToggled ? this.closeMenuClick : () => {}}
          role="none"
          onKeyPress={() => {}}
        />
        <div className={styles.container}>
          <button className={styles.button} onClick={this.handleClick}>
            {this.state.menuToggled ? (
              <p className={styles.cancel}>X</p>
            ) : (
              <Hamburger
                className={
                  this.props.dark ? styles.hamburgerDark : styles.hamburger
                }
              />
            )}
          </button>
          <div
            className={this.state.menuToggled ? styles.menu : styles.menuHidden}
          >
            <ul className={styles.menuList}>
              <li className={styles.menuListItem}>
                <Link
                  className={styles.link}
                  to="/"
                  onClick={this.closeMenuClick}
                >
                  Home
                </Link>
              </li>
              <li className={styles.menuListItem}>
                <Link
                  className={styles.link}
                  to="/about"
                  onClick={this.closeMenuClick}
                >
                  About Us
                </Link>
              </li>
              <li className={styles.menuListItem}>
                <Link
                  className={styles.link}
                  to="/contact"
                  onClick={this.closeMenuClick}
                >
                  Contact Us!
                </Link>
              </li>
              <li className={styles.menuListItem}>
                <Link
                  className={styles.link}
                  to="/policies"
                  onClick={this.closeMenuClick}
                >
                  Our Policies
                </Link>
              </li>
              <li>
                <BuildNumber />
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

Menu.propTypes = {
  dark: PropTypes.bool,
};

export default Menu;



// WEBPACK FOOTER //
// ./src/components/Menu.jsx